(ns io.repliance.util.transit
  (:require [cognitect.transit :as transit]))

;; TODO: If the frontend starts sending timestamps to backend, consider then the use of js-joda
;;       js-joda API maps to same class names as java.time package,
;;       so we can use java.time via (:import) in the ns form, e.g.
;;       #?(:clj (:import (java.time Instant ZonedDateTime LocalDate)
;;       and in cljs, use (:require) in the ns form, e.g.
;;       #?(:cljs ["@js-joda/core" :refer [LocalDate Instant ZonedDateTime]])

(def read-handlers
  {"Instant" (transit/read-handler #?(:clj #(java.time.Instant/ofEpochMilli %)
                                      :cljs #(js/Date. %)))})

(def write-handlers
  #?(:clj {java.time.Instant (transit/write-handler (constantly "Instant") (fn [^java.time.Instant v]
                                                                             (.toEpochMilli v)))}))
